module.exports = __webpack_public_path__ + "static/media/fvs_valve1_46.8d1349ac.jpg";